import {
	Route,
	createBrowserRouter,
	createRoutesFromElements,
} from "react-router-dom";
import Layaut from "../components/layaut/Layaut";
import Home from "./Home";
import Page_404 from "./Page_404";
import Account from "./Account";
import Login from "./Login";
import PrivacyPolicy from "./PrivacyPolicy";
import NewsletterConsent from "./NewsletterConsent";
import DataProcessingConsent from "./DataProcessingConsent";
import Offer from "./Offer";
import ForgotPassword from "./ForgotPassword";
import RestorePassword from "./RestorePassword";
import CourseView from "./CourseView";
import CourseContent from "./CourseContent";
import Logout from "./Logout";

const router = type => {

	return createBrowserRouter(
		createRoutesFromElements(
			<Route path="/" element={<Layaut />}>

				<Route
					index
					element={<Home />}
				/>
				<Route
					path="account"
					element={<Account />}
				/>
				<Route
					path="course-view/:courseId"
					element={<CourseView />}
				/>
				<Route
					path="course-content/:courseId"
					element={<CourseContent />}
				/>
				<Route
					path="login"
					element={<Login />}
				/>
				<Route
					path="restore-password"
					element={<RestorePassword />}
				/>
				<Route
					path="forgot-password"
					element={<ForgotPassword />}
				/>
				<Route
					path="privacy-policy"
					element={<PrivacyPolicy />}
				/>
				<Route
					path="newsletter-consent"
					element={<NewsletterConsent />}
				/>
				<Route
					path="data-processing-consent"
					element={<DataProcessingConsent />}
				/>
				<Route
					path="offer"
					element={<Offer />}
				/>
				<Route
					path="logout"
					element={<Logout />}
				/>


				<Route
					path="*"
					element={<Page_404 />}
				/>

			</Route>
		),
	);
};

export { router };
